import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import {
  APP_PAGES,
  INBOX_PREVIEW_FROM_VALUES,
  INBOX_PREVIEW_QUERY_PARAMS,
} from '../../routes/constants';
import { useDoBoxDropdownStore } from '../../store';

export function useNavigateToInboxPreview() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setFromDoBoxPreview } = useDoBoxDropdownStore();
  const isDobox = window.location.pathname.includes(APP_PAGES.DOBOX);
  const isLabels = window.location.pathname.includes(APP_PAGES.INBOX_LABELS);
  const isSnoozed = window.location.pathname.includes(APP_PAGES.INBOX_SNOOZED);

  const navigateToInboxPreview = (
    id: string,
    options?: { doboxId?: string },
  ) => {
    const currentTab = searchParams.get('tab');
    const basePath = isDobox ? APP_PAGES.DOBOX : APP_PAGES.INBOX;

    const params = new URLSearchParams();
    if (currentTab) {
      params.set('tab', currentTab);
    }
    if (isLabels) {
      params.set(
        INBOX_PREVIEW_QUERY_PARAMS.FROM,
        INBOX_PREVIEW_FROM_VALUES.LABELS,
      );
    }
    if (isSnoozed) {
      params.set(
        INBOX_PREVIEW_QUERY_PARAMS.FROM,
        INBOX_PREVIEW_FROM_VALUES.SNOOZED,
      );
    }
    if (options?.doboxId) {
      params.set(INBOX_PREVIEW_QUERY_PARAMS.DOBOX_ID, options.doboxId);
    }

    const previewPath = `${basePath}/preview/${encodeURIComponent(id)}`;
    const targetUrl = params.toString()
      ? `${previewPath}?${params.toString()}`
      : previewPath;

    if (isDobox && basePath === APP_PAGES.DOBOX) {
      setFromDoBoxPreview(true);
    } else {
      setFromDoBoxPreview(false);
    }

    navigate(targetUrl);
  };

  return { navigateToInboxPreview };
}
